import UpdateLocationDialog from "@/components/location/update-location-dialog";
import { useBoolean } from "@/hooks/use-boolean";
import { ShopLocationDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";
import { Pencil2Icon } from "@radix-ui/react-icons";

type LocationListItemProps = {
  location: ShopLocationDto;
};

export default function LocationListItem({ location }: LocationListItemProps) {
  const updateModal = useBoolean();

  return (
    <UpdateLocationDialog
      location={location}
      open={updateModal.value}
      onOpenChange={updateModal.setValue}
    >
      <LocationCard location={location} />
    </UpdateLocationDialog>
  );
}

const LocationCard = ({ location }: { location: ShopLocationDto }) => {
  const t = useTranslation();

  if (!location.address) return null;

  return (
    <div className="relative group h-auto transition-all hover:px-5 p-4 rounded-lg bg-transparent hover:bg-muted whitespace-normal w-full border border-border">
      <div className="items-center gap-8 flex justify-between h-full">
        <div className="flex flex-col justify-start items-start gap-2">
          <p className="text-base text-black font-medium leading-none tracking-tight">
            {location.address.companyName}
          </p>
          <p className="text-xs text-muted-foreground">
            {location.address.address1}, {location.address.city},{" "}
            {location.address.zip} {location.address.country_name}
          </p>
        </div>

        <div className="flex justify-center items-center">
          {location.isDefault && (
            <Badge
              variant="outline"
              className="transition-transform translate-x-0 opacity-100 group-hover:translate-x-5 group-hover:opacity-0"
            >
              {t("settings.shipping.fields.isDefault.title")}
            </Badge>
          )}
          <Pencil2Icon className="text-muted-foreground group-hover:opacity-100 group-hover:translate-x-0 translate-x-5 opacity-0 transition-transform" />
        </div>
      </div>
    </div>
  );
};
